import {sortByProperty} from 'helpers/sorters';
import BaseLineup from 'services/sports/default/base-lineup';

export default class LineupTiers extends BaseLineup {
    setPlayersByColumns({incomingValues: {team}}) {
        team.sort(sortByProperty('rosterPositionName'));

        team.map((player) => {
            player.positionInLineup = 'T' + player.rosterPositionName;
        });
        return team;
    }

    recalculateLineupsUsedPlayers({incomingValues: {lineups}}) {
        const usedPlayers = {};

        Object.values(lineups).map((lineup) => {
            lineup.players.map((player) => {
                const id = player.playerId;

                usedPlayers[id] ??= {...player, usedLineupsCount: 0};
                usedPlayers[id].usedLineupsCount++;
            });
        });

        return Object.values(usedPlayers);
    }
}
